export default __webpack_public_path__ + "static/media/observe-template.df7074f8.pdf";